module.exports = __webpack_public_path__ + "img/img_throw_6@2x_v3.33674498.png";